import includes from 'lodash/includes';
import { userType } from '@repo/shared/types';
export var isUserLimitOrAccountantType = function (merchantResponseData) {
    return includes([userType.enum.limit, userType.enum.limit2, userType.enum.ksiegowy], merchantResponseData.data.merchantData.user.type);
};
